export default {
    adaptiveMedia: "(max-width: 1000px)"
}